import React from "react";
//#region types
import { OrganizationProps } from "models/propTypes/userProfilePropTypes";
import { CommonConstants } from "utils/constants";
//#endregion
//#region components
import ProfileImage from "./profileImage";
import { Grid } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";
import { UtilsHelper } from "utils/helpers";

const Organization: React.FC<OrganizationProps> = (props) => {
  const location = useLocation();
  const navigate = useNavigate();

  const profileImage = <ProfileImage id={0} name={props.name} className={cssExports.listItemAvatar}></ProfileImage>;

  const formattedOrgNr =
    props.orgNr && !props.orgNr.includes("-")
      ? UtilsHelper.applyMask(props.orgNr, CommonConstants.OrganizationNumberMask)
      : props.orgNr;

  const onClick = (e?: React.MouseEvent) => {
    if (props.href) e?.stopPropagation();
    if (props.onProfileClick) props.onProfileClick();
    props.href &&
      navigate(props.href, {
        state: { background: location },
      });
  };

  return (
    <Grid container direction="row" columnGap={2} alignItems="center" wrap="nowrap" className={cssExports.organization}>
      <Grid item>
        <Grid item className={props.href ? cssExports.linkIcon : ""} onClick={onClick}>
          {profileImage}
        </Grid>
      </Grid>

      <Grid container item xs direction="column">
        <Grid item className={clsx(cssExports.orgName, cssExports.truncateString)}>
          <span className={props.href ? cssExports.linkText : ""} onClick={onClick}>
            {props.name}
          </span>
        </Grid>
        <Grid item className={clsx(cssExports.orgNr, cssExports.truncateString)}>
          {formattedOrgNr}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Organization;
